export interface Report {
    type: string,
    reported: any,
    reason: string,
    category: string,
    userKey: string,
    createdOn?: any
}


export class Report implements Report {

    public createdOn?: any;

    constructor(
        public type: string,
        public reported: any,
        public reason: string,
        public category: string,
        public userKey: string
    ) { }
}
